import type { ExplorationVolume } from '../../types/exploration';
import { buildRegionOptions } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxList from './FilterCheckboxList';

export default function RegionFilter({
  volumes,
  pendingRegionFilters,
  setPendingRegionFilters,
  isDisclosureOpen = false,
}: {
  volumes: ExplorationVolume[];
  pendingRegionFilters: string[];
  setPendingRegionFilters: (regions: string[]) => void;
  isDisclosureOpen?: boolean;
}) {
  const options = buildRegionOptions(volumes);

  const handleChange = (region: string) => {
    if (pendingRegionFilters.includes(region)) {
      setPendingRegionFilters(pendingRegionFilters.filter((r) => r !== region));
    } else {
      setPendingRegionFilters([...pendingRegionFilters, region]);
    }
  };

  if (!options.length) return null;

  return (
    <FilterCheckboxList
      options={options}
      isDisclosureOpen={isDisclosureOpen}
      isSelected={(key) => pendingRegionFilters.includes(key)}
      onToggle={handleChange}
    />
  );
}

export function buildRegionFilterOptions(volumes: ExplorationVolume[]) {
  return buildRegionOptions(volumes);
}
